export default __webpack_public_path__ + "static/media/hero_shape.cbc99fa0.svg";